<template>

  <v-container grid-list-xl fluid="true" class="ma-0 pa-0">
    <v-layout row wrap>

      <v-flex wrap xs12 md4 lg3 class="sidebar">

        <v-layout sm6>
          <v-flex xs12>
            <h4>Provider / project</h4>

            <v-select
                :items="providersOriginList"
                v-model="selectedOriginProvider"
                label="Select the provider"
                single-line
                @change="fillOriginProjects"
            ></v-select>

            <v-select
                :items="projectsOriginList"
                v-model="selectedOriginProject"
                label="Select the project"
                single-line
                v-if="projectsOriginList.length"
                @change="fillDestinationProviders"
            ></v-select>


          </v-flex>
        </v-layout>

        <v-layout sm6>
          <v-flex xs12>
            <h4>Destination</h4>

            <v-select
                :items="providersDestinationList"
                v-model="selectedDestinationProvider"
                label="Select the provider"
                single-line
                @change="fillDestinationProjects"
                v-if="providersDestinationList.length"
            ></v-select>

            <v-select
                :items="projectsDestinationList"
                v-model="selectedDestinationProject"
                label="Select the project"
                single-line
                v-if="projectsDestinationList.length"
                @change="getProjectTimeTracks"
            ></v-select>

          </v-flex>
        </v-layout>

        <v-layout sm6 class="calendar-wrapper" v-if="selectedDestinationProject !== null">
          <v-flex xs12>
            <h4>From</h4>
            <v-date-picker
                no-title
                v-model="dateFrom"
                @input="getProjectTimeTracks"
                full-width
            ></v-date-picker>
          </v-flex>
        </v-layout>

        <v-layout sm6 class="calendar-wrapper" v-if="selectedDestinationProject !== null">
          <v-flex xs12>
            <h4>To</h4>
            <v-date-picker
                no-title
                v-model="dateTo"
                @input="getProjectTimeTracks"
                full-width
            ></v-date-picker>
          </v-flex>
        </v-layout>

        <v-layout xs12 class="full-width">
          <v-flex xs12>
            <v-checkbox
                label="Show no tracked only"
                hide-details
                @change="filterTrackedItems"
            ></v-checkbox>
          </v-flex>
        </v-layout>

      </v-flex>

      <v-flex xs12 md8 lg9 class="content">


        <v-flex xs12>

          <!-- @todo this button should be only enabled if all selected rows are NOT sync-->
          <v-btn
              color="info"
              @click="registerTimes"
              :disabled="Boolean(selectedRows.length === 0)"
          >Sync selected items
          </v-btn>

          <!-- @todo this button should be only enabled if all selected rows are sync-->
          <v-btn
              color="warning"
              @click="rollbackTimes"
              :disabled="Boolean(selectedRows.length === 0)"
          >Rollback selected items
          </v-btn>

        </v-flex>


        <v-data-table
            v-model="selectedRows"
            :headers="headers"
            :items="processedTimeEntries"
            item-key="timeEntryId"
            select-all
            class="elevation-1"
            hide-actions
        >

          <template slot="items" slot-scope="props">
            <tr :class="{'green lighten-4': props.item.synced}" v-if="props.item.show">
              <td>
                <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
              </td>
              <td>{{ props.item.desc }}</td>
              <td v-html="props.item.timeSpent"></td>
              <td><a :href="props.item.issueUrl" target="_blank">{{ props.item.issueKey }}</a></td>
            </tr>
          </template>
        </v-data-table>

      </v-flex>

    </v-layout>
  </v-container>

</template>

<script>
import { mapState } from "vuex"
import moment from "moment"
import _ from "lodash"
import rest from '@/plugins/rest'

const firstDayOfCurrentMonth = moment().startOf('month').toISOString(true).substr(0, 10);
const lastDayOfCurrentMonth = moment().endOf('month').toISOString(true).substr(0, 10);

export default {
  data() {
    return {

      providersOriginList: [],
      selectedOriginProvider: null,
      projectsOriginList: [],
      selectedOriginProject: null,

      providersDestinationList: [],
      selectedDestinationProvider: null,
      projectsDestinationList: [],
      selectedDestinationProject: null,

      dateFrom: firstDayOfCurrentMonth,
      dateTo: lastDayOfCurrentMonth,

      // Hols the timetracks provinding from a provider & project pair
      timeEntries: [],
      // This is a processed version of timeEntries done in watch zone.
      // It's intented for visual representations. For real data use timeEntries.
      processedTimeEntries: [],
      selectedRows: [],
      headers: [
        {
          text: 'Time track comment',
          value: "timeEntryComment",
          sortable: false
        },
        {
          text: 'Time spent',
          value: "timeSpent",
          sortable: false
        },
        {
          text: 'Issue',
          value: "issueId",
          sortable: false
        }
      ],

    }
  },

  methods: {

    /**
     * Fetches all time tracks related to a provider.
     */
    getProjectTimeTracks() {
      const self = this
      const destinationProjectKey = self.projectsDestinationList.filter(item => String(item.value) === String(self.selectedDestinationProject), self)[0].key

      const conf = {
        originProvider: self.selectedOriginProvider,
        originProject: self.selectedOriginProject,
        destinationProvider: self.selectedDestinationProvider,
        destinationProject: self.selectedDestinationProject,
        destinationProjectKey: destinationProjectKey,
        from: self.dateFrom,
        to: self.dateTo
      }

      rest.getTimeEntries(conf).then(timeEntries => {
        self.timeEntries = timeEntries
      })
    },

    fillOriginProviders() {
      const self = this

      rest.getMatchedProjects().then(r => {
        r.forEach(doc => {
          self.providersOriginList.push({
            text: `${doc.hydrated.providerFrom.label} (${doc.hydrated.providerFrom.type})`,
            value: doc.hydrated.providerFrom._id,
            fullVaues: doc.hydrated.providerFrom
          })
        })
      })
    },

    fillOriginProjects() {
      const self = this
      self.projectsOriginList = []

      rest.getMatchedProjects({providerFrom: self.selectedOriginProvider}).then(r => {

        r.forEach(doc => {
          self.projectsOriginList.push({
            text: doc.hydrated.projectFrom.name,
            value: doc.hydrated.projectFrom.id
          })
        })
      })

    },

    fillDestinationProviders() {
      const self = this
      self.providersDestinationList = []

      rest.getMatchedProjects({
        providerFrom: self.selectedOriginProvider,
        projectFrom: self.selectedOriginProject
      }).then(r => {
        r.forEach(doc => {
          self.providersDestinationList.push({
            text: `${doc.hydrated.providerTo.label} (${doc.hydrated.providerTo.type})`,
            value: doc.hydrated.providerTo._id,
            fullVaues: doc.hydrated.providerTo
          })
        })
      })

      // Reset selected destination provider since
      // next step for user is to pick the new one.
      // self.selectedDestinationProvider = null
    },

    fillDestinationProjects() {
      const self = this
      self.projectsDestinationList = []

      rest.getMatchedProjects({
        providerFrom: self.selectedOriginProvider,
        projectFrom: self.selectedOriginProject,
        providerTo: self.selectedDestinationProvider
      }).then(r => {
        r.forEach(doc => {
          self.projectsDestinationList.push({
            text: doc.hydrated.projectTo.name,
            value: doc.hydrated.projectTo.id,
            key: doc.hydrated.projectTo.key,
          })
        })
      })

    },

    registerTimes() {
      const self = this
      const timeEntries = []

      self.selectedRows.forEach((row) => {

        if (row.issueKey !== null && !row.synced) {
          timeEntries.push({
            originProvider: self.selectedOriginProvider,
            originProject: self.selectedOriginProject,
            destinationProvider: self.selectedDestinationProvider,
            destinationProject: self.selectedDestinationProject,
            issue: {
              id: row.issueKey
            },
            timeEntry: {
              id: row.timeEntryId,
              dateStart: row.dateStart,
              dateEnd: row.dateEnd,
              duration: row.duration,
              desc: row.desc,
            },
          })
        }
      })

      if (timeEntries.length) {
        rest.registerTimeEntries({provider: self.selectedDestinationProvider, timeEntries: timeEntries}).then(r => {
          // Unselect all checkbockes.
          self.selectedRows = []

          // Refresh the list.
          self.getProjectTimeTracks()
        })
      }
      else {
        // @todo show a snack indicating there are no untracked items selected on the table.
        console.log('@todo show a snack indicating there are no untracked items selected on the table');
      }

    },

    rollbackTimes() {
      const self = this
      const timeEntries = []

      self.selectedRows.forEach((row) => {
        if (row.synced) {
          timeEntries.push({
            originProvider: self.selectedOriginProvider,
            originProject: self.selectedOriginProject,
            destinationProvider: self.selectedDestinationProvider,
            destinationProject: self.selectedDestinationProject,
            destinationTimeEntryId: row.destinationTimeEntryId,
            issue: {
              id: row.issueKey
            },
            timeEntry: {
              id: row.timeEntryId,
            },
          })
        }
      })

      if (timeEntries.length) {
        rest.unregisterTimeEntries({provider: self.selectedDestinationProvider, timeEntries: timeEntries}).then(r => {
          // Unselect all checkbockes.
          self.selectedRows = []

          // Refresh the list.
          self.getProjectTimeTracks()
        })
      }
      else {
        // @todo show a snack indicating there are no tracked items selected on the table.
        console.log('@todo show a snack indicating there are no tracked items selected on the table');
      }

    },

    humanizeDate: function (value) {
      if (!value) {
        return '';
      }
      return moment(value).toISOString(true).substr(0, 10);
    },

    humanizeSpentTime: function (value) {
      if (!value) {
        return '';
      }
      let duration = moment.duration(value, 'seconds');
      return `${duration.hours()}h ${duration.minutes()}m`;
    },

    /**
     * Filter out all registered items.
     *
     * @param {Boolean} applyFilter
     */
    filterTrackedItems(applyFilter) {
      const self = this

      self.processedTimeEntries = self.processedTimeEntries.map((item) => {
        item.show = applyFilter ? !item.synced : true
        return item;
      });
    },

    isSameDay(start, end) {
      let sDate = moment(start).format('YYYY-MM-DD');
      let eDate = moment(end).format('YYYY-MM-DD');
      return sDate === eDate;
    }

  },

  computed: {
    ...mapState([
      'currentUser',
    ]),
  },

  mounted: function () {
    this.fillOriginProviders()
  },

  watch: {

    /**
     * Process incoming values assigned to timeEntries
     *
     * Here we appy all conditionals and generate
     * items ready to be used at the main table.
     *
     * @param items
     * @returns {[]}
     */
    timeEntries: function (items) {
      const self = this
      const processedItems = []

      items.forEach(item => {
        const processedItem = {}

        processedItem.desc = item.timeEntryComment !== ('' || null) ? item.timeEntryComment : `Working on issue`

        let timeSpent = ''

        if (self.isSameDay(item.dateStart, item.dateEnd)) {
          timeSpent = `<strong>${self.humanizeSpentTime(item.duration)}</strong> (${self.humanizeDate(item.dateStart)})`
        }
        else {
          timeSpent = `<strong>${self.humanizeSpentTime(item.duration)}</strong> (${self.humanizeDate(item.dateStart)} / ${self.humanizeDate(item.dateEnd)})`
        }

        processedItem.timeSpent = timeSpent
        processedItem.issueProjectLabel = item.issueProjectLabel
        processedItem.issueKey = item.issueKey
        processedItem.timeEntryId = item.timeEntryId
        processedItem.duration = item.duration
        processedItem.dateStart = item.dateStart
        processedItem.dateEnd = item.dateEnd
        processedItem.synced = item.synced
        processedItem.destinationTimeEntryId = item.destinationTimeEntryId

        // This flag is used to visually control the item visibility.
        processedItem.show = true

        const issueBaseUrl = self.providersOriginList.filter(item => String(item.value) === String(self.selectedOriginProvider), self)[0].fullVaues.url;
        processedItem.issueUrl = issueBaseUrl.replace(':issueId', item.issueKey)

        processedItems.push(processedItem)
      })

      self.processedTimeEntries = processedItems
    },

  }


}
</script>